import { Fragment, useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardFooter } from 'reactstrap'
import Loader from 'react-loaders'
import TransitionOnLoad from "Components/TransitionOnLoad";
import PageHeading from 'Layout/AppMain/PageHeading';
import axiosInstance from 'Api';
import Algemeen from './Forms/Algemeen';
import Terugkoppeling from './Forms/Terugkoppeling';
import KolommenPlanscherm from './Forms/KolommenPlanscherm';
import PlanningService from 'Api/Instellingen/Planning';
import { debounce } from 'helperFunctions/index';
import { toast } from 'react-toastify';
import { useApiMutation } from 'services/useApiMutation';
import useSWR from 'swr';
import { useContractTypes } from 'Api/Coordinator/Gebruikers/GebruikerView';

const Planning = () => {
    const [errorField, setErrorField] = useState({});
    const [communityId, setCommunityId] = useState('');
    const { trigger: savePlanningMutation } = useApiMutation();

    const {
        data: communityResponse,
        isLoading: communityLoading,
    } = useSWR(
        "organizations-list",
        () => axiosInstance.get("organizations-list")
    );

    const communityList =
        communityResponse?.data.data || [];


    useEffect(() => {
        if (communityList) { setCommunityId(communityList[0]?.iCommunityId); }
    }, [communityList]);

    const {
        data: contractResponse,
        isLoading: contractLoading,
    } = useContractTypes(communityId);

    const standaardContracttype =
        contractResponse?.data || [];

    let customContractTypeList;

    if (standaardContracttype) {
        customContractTypeList = standaardContracttype.map(item => ({
            ...item,
            label: `${item.vContractTypeAbbr} - ${item.vContractTypeName}`
        }));

    }


    const {
        data: planningResponse,
        mutate: refreshPlanning,
        isLoading: planningLoading,
    } = useSWR(
        communityId
            ? ["planning", communityId]
            : null,
        ([, communityId]) =>
            PlanningService.fetchPlanning(
                communityId
            )
    );

    const planning =
        planningResponse?.data?.data || {};


    const sanitizeMessage = (text = "") => {

        return String(text)
            .replace(/\[([^\]]+)\]/g, '$1')
            .replace(/@@(\d+)\|([^@]+)@@/g, '@$2')
            .replace(/\n+/g, ' ')
            .replace(/(@[^\s]+)\s+@/g, '$1 @')
            .replace(/^\s+|\s+$/g, '')
            .replace(/\s+$/, '')
            .trim();
    };


    const callApi = (field, value, setFieldError, setLoadingKeys, iPlanId = null) => {

        const cleanedNote = sanitizeMessage(value)
        const data = {
            iCommunityId: communityId,
            ...(field ? { attr: field } : {}),
            [field]: cleanedNote,
            ...(iPlanId > 0 ? { iPlanId: iPlanId } : {})
        }

        savePlanningMutation(() =>
            PlanningService.saveOrUpdate(data)
        )
            .then(response => {

                if (response.status) {
                    refreshPlanning();
                    setErrorField(null);
                }

                if (!response.status) {
                    setErrorField(field);
                    const errors = response.data[field];
                    if (setFieldError) {
                        setFieldError(field, "required");
                    }

                    if (Array.isArray(errors)) {
                        toast.error(errors.join(','));
                    } else {
                        toast.error(errors);
                    }
                }
            })
            .catch(error => {
                console.error('API error:', error);
            }).finally(() => {
                if (setLoadingKeys) setLoadingKeys(prev => ({ ...prev, [field]: false }));
            });
    };

    const debouncedApiCall = useMemo(() => debounce(callApi, 4000), [communityId]);

    const handleFieldChange = (field, value, setFieldError = null) => {
        setErrorField('');
        debouncedApiCall(field, value, setFieldError);
    };

    const handleIconFieldChange = (field, value, setLoadingKeys, iPlanId) => {
        setErrorField('');
        callApi(field, value, null, setLoadingKeys, iPlanId);
    };

    const orgName = useMemo(() => {
        return communityList?.find(item => item.iCommunityId === Number(communityId))?.name || ""
    }, [communityId, communityList]);

    return (
        <Fragment>
            <PageHeading orgName={orgName} />
            {
                (communityLoading || planningLoading || contractLoading) ?
                    <TransitionOnLoad>
                        <Card className="main-card">
                            <CardBody className="d-flex flex-column">
                                <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                            </CardBody>
                        </Card>
                    </TransitionOnLoad> : <>
                        {planning && <div className='row contract-typen-view mb-5'>
                            <div className='col-xl-6 p-2'>
                                <Algemeen planning={planning} changeHandler={handleFieldChange} handleIconFieldChange={handleIconFieldChange} customContractTypeList={customContractTypeList} errorField={errorField} communityId={communityId} />
                            </div>
                            <div className="col-xl-6 p-2">
                                <KolommenPlanscherm planning={planning} handleIconFieldChange={handleIconFieldChange} />
                            </div>
                            <div className='col-xl-6 p-2'>
                                <Terugkoppeling planning={planning} changeHandler={handleFieldChange} handleIconFieldChange={handleIconFieldChange} customContractTypeList={customContractTypeList} communityId={communityId} refreshPlanning={refreshPlanning} />
                            </div>
                        </div>
                        }

                        <div className="chat-layout-footer py-5">
                            <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                                <div className="d-flex gap-3">
                                    <div>
                                        <select className={`form-select`} value={communityId} onChange={(e) => { setCommunityId(e.target.value) }}>
                                            <option value={''} disabled>Alle besturen</option>
                                            {communityList?.map(item => {
                                                return <option key={item.iCommunityId} value={item.iCommunityId}>{item.name}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </CardFooter>
                        </div>
                    </>
            }
        </Fragment>
    )
}

export default Planning